import styled from 'styled-components';

import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { themeVar } from '@/styles/theme';
import { IInvestmentEntityByAdvisoryFirm } from '../../types';
import { advisorColumns } from '../constants';

interface TableSumFooterProps {
  listInvestmentEntityByAdvisoryFirm: IInvestmentEntityByAdvisoryFirm[];
}

const TableSumFooterAdvisor = ({ listInvestmentEntityByAdvisoryFirm }: TableSumFooterProps) => {
  const total = listInvestmentEntityByAdvisoryFirm.reduce<{
    estimatedCommitment: number;
    taxableEstimate: number;
    exemptEstimate: number;
  }>(
    (sum, value: IInvestmentEntityByAdvisoryFirm) => {
      return {
        estimatedCommitment: (sum.estimatedCommitment += Number(value.estimatedCommitment)),
        taxableEstimate: (sum.taxableEstimate += Number(value.estimatedTaxableCommitment)),
        exemptEstimate: (sum.exemptEstimate += Number(value.estimatedExemptCommitment))
      };
    },
    { estimatedCommitment: 0, taxableEstimate: 0, exemptEstimate: 0 }
  );

  return (
    <TableSumWrap>
      <TableSumItem width={advisorColumns[0].width}>Total</TableSumItem>
      <TableSumItem width={advisorColumns[1].width}>
        <FormattingTooltip zIndex={1000}>{total.taxableEstimate}</FormattingTooltip>
      </TableSumItem>
      <TableSumItem width={advisorColumns[2].width}>
        <FormattingTooltip zIndex={1000}>{total.exemptEstimate}</FormattingTooltip>
      </TableSumItem>
      <TableSumItem width={advisorColumns[3].width}>
        <FormattingTooltip zIndex={1000}>{total.estimatedCommitment}</FormattingTooltip>
      </TableSumItem>
      <TableSumItem width={advisorColumns[4].width}></TableSumItem>
      <TableSumItem width={advisorColumns[5].width}></TableSumItem>
      <TableSumItem width={advisorColumns[6].width}></TableSumItem>
    </TableSumWrap>
  );
};

const TableSumWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 24px;
  width: 100%;
  min-height: 60px;
  background-color: ${themeVar('layer.2')};
  border-radius: 8px;
  margin-top: 6px;
  margin-bottom: 30px;
`;

const TableSumItem = styled.div<{ width?: number; justifyContent?: string }>`
  display: flex;
  justify-content: ${({ justifyContent }) => `${justifyContent}`};
  width: ${({ width }) => `${width}%`};
  color: ${themeVar('font.base')};
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
`;

export default TableSumFooterAdvisor;
